module.exports = __webpack_public_path__ + "img/membership-1-desktop.be7263de.png";